import React from 'react';
import 'js/pageComponents';
import 'intersection-observer';
import 'js/components/tagTypes';
import { store } from 'js/store';
import { Provider } from 'react-redux';
import { render, hydrate } from 'react-dom';
import { SnackbarProvider } from 'notistack';
import { Router } from 'js/components/system/Router';

import 'styles/main.scss';

export const renderApp = ({ container }) => {
    const App = (
        <SnackbarProvider maxSnack={5}>
            <Provider store={store}>
                <Router />
            </Provider>
        </SnackbarProvider>
    );

    container.dataset.serverRendered ? hydrate(App, container) : render(App, container);

    return null;
};

export * from 'js/backbone/exports';
